"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingCell = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.LoadingCell = (0, styled_1.default)(`div`) `
  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }

  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: ${(0, ui_theme_1.fromTheme)('color_background_secondary')};
  background: linear-gradient(
    to right,
    ${(0, ui_theme_1.fromTheme)('color_button_secondary')} 10%,
    ${(0, ui_theme_1.fromTheme)('color_button_secondary_hover')} 18%,
    ${(0, ui_theme_1.fromTheme)('color_button_secondary')} 33%
  );
  background-size: 1000px 640px;
  height: 20px;
`;
//# sourceMappingURL=LoadingBody.styles.js.map